const canvas = document.getElementById('schematic');
const ctx = canvas.getContext('2d');
const NODE_WIDTH = 100, NODE_HEIGHT = 36;

const randomWords = ['IT', 'ALL', 'STARTED', 'ON', 'A', 'SHARED', 'NETWORK'];
const overlayDescriptions = ["Ethernet Institute: Site in progress."];

let nodes = [], connections = [];
let selectedNode = null, draggingNode = null;
let dragOffsetX = 0, dragOffsetY = 0;
let needsRedraw = true;

const alignBtn = document.createElement('button');
alignBtn.textContent = "?";
alignBtn.style.position = "fixed";
alignBtn.style.top = "16px";
alignBtn.style.left = "16px";
alignBtn.style.zIndex = 1000;
alignBtn.style.padding = "4px 8px";
alignBtn.style.fontSize = "13px";
alignBtn.style.background = "#222";
alignBtn.style.color = "#fff";
alignBtn.style.border = "2px solidrgb(255, 255, 255)";
alignBtn.style.borderRadius = "6px";
alignBtn.style.cursor = "pointer";
document.body.appendChild(alignBtn);

function alignNodesToMessage() {
    const message = "IT ALL STARTED ON A SHARED NETWORK";
    const words = message.split(' ');
    const totalNodes = nodes.length;
    const leftMargin = 60;
    const rightMargin = 60;
    const usableWidth = canvas.displayWidth - leftMargin - rightMargin;
    const wordCount = words.length;
    const spacing = wordCount > 1 ? usableWidth / (wordCount - 1) : 0;
    const centerY = canvas.displayHeight / 2;

    // Prepare target positions and words
    const targets = [];
    for (let i = 0; i < totalNodes; i++) {
        const wordIdx = i % wordCount;
        const x = leftMargin + wordIdx * spacing;
        const y = centerY + ((i / wordCount) | 0) * 60 - 30;
        targets.push({ x, y, desc: words[wordIdx] });
    }

    // Store initial positions
    const startPositions = nodes.map(n => ({ x: n.x, y: n.y, desc: n.desc }));

    const duration = 1000;
    const startTime = performance.now();

    function animateAlign(now) {
        const t = Math.min(1, (now - startTime) / duration);
        for (let i = 0; i < totalNodes; i++) {
            // Lerp position
            nodes[i].x = startPositions[i].x + (targets[i].x - startPositions[i].x) * t;
            nodes[i].y = startPositions[i].y + (targets[i].y - startPositions[i].y) * t;
            nodes[i].desc = targets[i].desc;
            nodes[i].vx = 0;
            nodes[i].vy = 0;
        }
        needsRedraw = true;
        if (t < 1) {
            requestAnimationFrame(animateAlign);
        } else {
            // After 1s, randomize velocities again
            setTimeout(() => {
                for (let i = 0; i < nodes.length; i++) {
                    nodes[i].vx = (Math.random() - 0.5) * 0.7;
                    nodes[i].vy = (Math.random() - 0.5) * 0.7;
                }
            }, 1000);
        }
    }
    requestAnimationFrame(animateAlign);
}

alignBtn.addEventListener('click', alignNodesToMessage);

function generateNodes() {
    nodes.length = 14;
    for (let i = 0; i < 14; i++) {
        const marginX = NODE_WIDTH, marginY = NODE_HEIGHT;
        const x = Math.random() * (canvas.displayWidth - 2 * marginX) + marginX;
        const y = Math.random() * (canvas.displayHeight - 2 * marginY) + marginY;
        const desc = randomWords[(Math.random() * randomWords.length) | 0];
        const vx = (Math.random() - 0.5) * 0.7, vy = (Math.random() - 0.5) * 0.7;
        nodes[i] = { x, y, desc, vx, vy, _shape: null };
    }
}

function generateConnections() {
    const conns = new Set();
    for (let i = 0; i < nodes.length; i++) {
        const num = (Math.random() * 3 + 1) | 0;
        for (let j = 0; j < num; j++) {
            let target = (Math.random() * nodes.length) | 0;
            if (target !== i) {
                const key = i < target ? `${i},${target}` : `${target},${i}`;
                conns.add(key);
            }
        }
    }
    const arr = [];
    conns.forEach(k => {
        const [a, b] = k.split(',').map(Number);
        arr.push([a, b]);
    });
    return arr;
}

function resize() {
    const dpr = window.devicePixelRatio || 1;
    const displayWidth = window.innerWidth;
    const displayHeight = window.innerHeight;
    
    if (canvas.width === displayWidth * dpr && canvas.height === displayHeight * dpr) return;
    
    canvas.width = displayWidth * dpr;
    canvas.height = displayHeight * dpr;
    canvas.style.width = displayWidth + 'px';
    canvas.style.height = displayHeight + 'px';
    
    ctx.scale(dpr, dpr);
    
    canvas.displayWidth = displayWidth;
    canvas.displayHeight = displayHeight;
    
    generateNodes();
    connections = generateConnections();
    needsRedraw = true;
}
window.addEventListener('resize', resize);

function draw() {
    ctx.clearRect(0, 0, canvas.displayWidth, canvas.displayHeight);

    // Draw connections
    ctx.save();
    ctx.lineWidth = 1;
    for (let i = 0; i < connections.length; i++) {
        const [a, b] = connections[i];
        const na = nodes[a], nb = nodes[b];
        ctx.strokeStyle = (selectedNode !== null && (a === selectedNode || b === selectedNode)) ? '#ff0000' : '#fff';
        ctx.beginPath();
        let midX, midY;
        if (selectedNode !== null && (a === selectedNode || b === selectedNode)) {
            const midX1 = na.x + (nb.x - na.x) / 3;
            const midX2 = na.x + 2 * (nb.x - na.x) / 3;
            ctx.moveTo(na.x, na.y);
            ctx.lineTo(midX1, na.y);
            ctx.lineTo(midX1, nb.y);
            ctx.lineTo(midX2, nb.y);
            ctx.lineTo(nb.x, nb.y);
            midX = midX1;
            midY = (na.y + nb.y) / 2;
        } else {
            const dx = nb.x - na.x, dy = nb.y - na.y, curveStrength = 0.8;
            ctx.moveTo(na.x, na.y);
            ctx.bezierCurveTo(
                na.x + dx * curveStrength, na.y,
                nb.x - dx * curveStrength, nb.y,
                nb.x, nb.y
            );
            midX = (na.x + nb.x) / 2;
            midY = (na.y + nb.y) / 2 - 18;
        }
        ctx.stroke();

        // Draw distance label
        const dist = Math.hypot(nb.x - na.x, nb.y - na.y);
        ctx.save();
        ctx.font = "10px Arial";
        ctx.fillStyle = "#ff0";
        ctx.strokeStyle = "#222";
        ctx.lineWidth = 3;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.strokeText(dist.toFixed(1), midX, midY);
        ctx.fillText(dist.toFixed(1), midX, midY);
        ctx.restore();
    }
    ctx.restore();

    // Draw nodes
    ctx.font = "bold 14px Arial";
    for (let idx = 0; idx < nodes.length; idx++) {
        const node = nodes[idx];
        ctx.save();
        const isOval = idx % 2 === 1;
        const textWidth = ctx.measureText(node.desc).width;
        const padding = 28;
        let width = Math.max(NODE_WIDTH, textWidth + padding);
        let height = NODE_HEIGHT;

        if (isOval) {
            let ovalWidth = width, ovalHeight = Math.max(NODE_HEIGHT, NODE_HEIGHT * 0.7);
            ctx.beginPath();
            ctx.lineWidth = (selectedNode === idx) ? 5 : 3;
            ctx.strokeStyle = (selectedNode === idx) ? '#ff0000' : '#fff';
            ctx.fillStyle = '#000';
            ctx.ellipse(node.x, node.y, ovalWidth / 2, ovalHeight / 2, 0, 0, 2 * Math.PI);
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.stroke();

            ctx.fillStyle = "white";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(node.desc, node.x, node.y);

            ctx.font = "10px Arial";
            ctx.textAlign = "left";
            ctx.textBaseline = "bottom";
            ctx.fillText(idx + 1, node.x - ovalWidth / 2, node.y - ovalHeight / 2 - 4);

            node._shape = { type: 'oval', w: ovalWidth, h: ovalHeight };
        } else {
            ctx.beginPath();
            ctx.lineWidth = (selectedNode === idx) ? 5 : 3;
            ctx.strokeStyle = (selectedNode === idx) ? '#ff0000' : '#fff';
            ctx.fillStyle = '#000';
            ctx.rect(node.x - width / 2, node.y - height / 2, width, height);
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.stroke();

            ctx.fillStyle = "white";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(node.desc, node.x, node.y);

            ctx.font = "10px Arial";
            ctx.textAlign = "left";
            ctx.textBaseline = "bottom";
            ctx.fillText(idx + 1, node.x - width / 2, node.y - height / 2 - 4);

            node._shape = { type: 'rect', w: width, h: height };
        }
        ctx.restore();
    }

    drawOverlay();
}

// Optimized hit test for both ovals and rectangles
function getNodeAt(x, y) {
    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (!node._shape) continue;
        if (node._shape.type === 'rect') {
            const { w, h } = node._shape;
            if (x >= node.x - w / 2 && x <= node.x + w / 2 && y >= node.y - h / 2 && y <= node.y + h / 2)
                return i;
        } else {
            const { w, h } = node._shape;
            const dx = x - node.x, dy = y - node.y;
            if ((dx * dx) / ((w / 2) * (w / 2)) + (dy * dy) / ((h / 2) * (h / 2)) <= 1)
                return i;
        }
    }
    return -1;
}

const overlayCache = {};
function drawOverlay() {
    if (selectedNode === null) return;
    const node = nodes[selectedNode];
    const overlayPadding = 24, minOverlayWidth = 220, minOverlayHeight = 80, lineHeight = 18;
    const overlayDesc = overlayDescriptions[selectedNode % overlayDescriptions.length];
    const descText = overlayDesc;

    ctx.save();
    ctx.font = "14px Arial";
    const maxTextWidth = 300;
    let cacheKey = descText;
    let lines = overlayCache[cacheKey];
    if (!lines) {
        let words = descText.split(' '), lns = [], line = '';
        for (let i = 0; i < words.length; i++) {
            let word = words[i];
            let testLine = line ? line + ' ' + word : word;
            if (ctx.measureText(testLine).width > maxTextWidth && line) {
                lns.push(line);
                line = word;
            } else {
                line = testLine;
            }
        }
        if (line) lns.push(line);
        overlayCache[cacheKey] = lns;
        lines = lns;
    }

    let maxLineWidth = 0;
    for (let i = 0; i < lines.length; i++) {
        const w = ctx.measureText(lines[i]).width;
        if (w > maxLineWidth) maxLineWidth = w;
    }
    const overlayWidth = Math.max(minOverlayWidth, Math.min(maxTextWidth + overlayPadding, maxLineWidth + overlayPadding));
    const overlayHeight = Math.max(minOverlayHeight, 36 + lines.length * lineHeight);

    const overlayX = Math.max(10, Math.min(canvas.displayWidth - overlayWidth - 10, node.x + NODE_WIDTH / 2 + 16));
    const overlayY = Math.max(10, Math.min(canvas.displayHeight - overlayHeight - 10, node.y - overlayHeight / 2));

    ctx.globalAlpha = 0.95;
    ctx.fillStyle = "#222";
    ctx.strokeStyle = "#ff0000";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.rect(overlayX, overlayY, overlayWidth, overlayHeight);
    ctx.fill();
    ctx.stroke();

    ctx.fillStyle = "#fff";
    ctx.font = "bold 16px Arial";
    ctx.textAlign = "left";
    ctx.textBaseline = "top";
    ctx.fillText("Node #" + (selectedNode + 1), overlayX + 12, overlayY + 10);

    ctx.font = "14px Arial";
    ctx.fillStyle = "#ff8080";
    for (let i = 0; i < lines.length; i++) {
        ctx.fillText(lines[i], overlayX + 12, overlayY + 36 + i * lineHeight);
    }
    ctx.restore();
}

function getPointerPos(e) {
    const rect = canvas.getBoundingClientRect();
    let clientX = e.touches?.[0]?.clientX ?? e.clientX;
    let clientY = e.touches?.[0]?.clientY ?? e.clientY;
    const mx = (clientX - rect.left) * (canvas.displayWidth / rect.width);
    const my = (clientY - rect.top) * (canvas.displayHeight / rect.height);
    return { mx, my };
}

canvas.addEventListener('pointerdown', e => {
    const { mx, my } = getPointerPos(e);
    const idx = getNodeAt(mx, my);
    if (idx !== -1) {
        draggingNode = idx;
        selectedNode = idx;
        dragOffsetX = mx - nodes[idx].x;
        dragOffsetY = my - nodes[idx].y;
        needsRedraw = true;
    }
});

canvas.addEventListener('pointermove', e => {
    if (draggingNode !== null) {
        const { mx, my } = getPointerPos(e);
        let node = nodes[draggingNode];
        let shape = node._shape;
        let w = shape ? shape.w : NODE_WIDTH, h = shape ? shape.h : NODE_HEIGHT;
        let newX = Math.max(w / 2, Math.min(canvas.displayWidth - w / 2, mx - dragOffsetX));
        let newY = Math.max(h / 2, Math.min(canvas.displayHeight - h / 2, my - dragOffsetY));
        if (node.x !== newX || node.y !== newY) {
            node.x = newX;
            node.y = newY;
            needsRedraw = true;
        }
    }
});

canvas.addEventListener('pointerup', () => draggingNode = null);
canvas.addEventListener('pointerleave', () => draggingNode = null);

canvas.addEventListener('click', e => {
    if (draggingNode !== null) return;
    const { mx, my } = getPointerPos(e);
    const idx = getNodeAt(mx, my);
    if (selectedNode !== idx) {
        selectedNode = idx !== -1 ? idx : null;
        needsRedraw = true;
    }
});

function animate() {
    let moved = false;
    for (let i = 0; i < nodes.length; i++) {
        if (draggingNode === i) continue;
        let node = nodes[i];
        let oldX = node.x, oldY = node.y;
        node.x += node.vx;
        node.y += node.vy;
        let shape = node._shape;
        let w = shape ? shape.w : NODE_WIDTH, h = shape ? shape.h : NODE_HEIGHT;
        // Bounce off edges
        if (node.x < w / 2 || node.x > canvas.displayWidth - w / 2) node.vx *= -1;
        if (node.y < h / 2 || node.y > canvas.displayHeight - h / 2) node.vy *= -1;
        node.x = Math.max(w / 2, Math.min(canvas.displayWidth - w / 2, node.x));
        node.y = Math.max(h / 2, Math.min(canvas.displayHeight - h / 2, node.y));
        if (node.x !== oldX || node.y !== oldY) moved = true;
    }
    if (needsRedraw || moved) {
        draw();
        needsRedraw = false;
    }
    requestAnimationFrame(animate);
}

resize();
animate();
